// 表示算出共通ロジック
function calcBottomForPostionTop ({ anchorEl, thisRect, useOffset, additionalOffset }) {
	const anchorRect = anchorEl.getBoundingClientRect()
	let bottom = window.innerHeight - anchorRect.bottom
	if (useOffset) bottom = bottom + anchorRect.height
	bottom = bottom + additionalOffset
	return bottom
}
function calcTopForPositionBottom ({ anchorEl, thisRect, useOffset, additionalOffset }) {
	const anchorRect = anchorEl.getBoundingClientRect()
	let top = anchorRect.top
	if (useOffset) top = top + anchorRect.height
	top = top + additionalOffset
	return top
}
function calcLeftForPositionRight ({ anchorEl, thisRect, useOffset, additionalOffset }) {
	const anchorRect = anchorEl.getBoundingClientRect()
	let left = anchorRect.left
	if (useOffset) left = left + anchorRect.width
	left = left + additionalOffset
	return left
}
function calcRightForPositionLeft ({ anchorEl, thisRect, useOffset, additionalOffset }) {
	const anchorRect = anchorEl.getBoundingClientRect()
	let right = window.innerWidth - anchorRect.right
	if (useOffset) right = right + anchorRect.width
	right = right + additionalOffset
	return right
}

// y座標計算用
export const verticalCalculators = {
	bottom: {
		calc ({ anchorEl, thisRect, useOffset, additionalOffset }) {
			const top = calcTopForPositionBottom({ anchorEl, thisRect, useOffset, additionalOffset })

			// 下にはみ出す場合
			if (window.innerHeight < top + thisRect.height) {
				// useOffsetの場合、対象要素に被らないことが求められるため、下表示に切り替え
				if (useOffset) {
					return {
						bottom: `${calcBottomForPostionTop({ anchorEl, thisRect, useOffset, additionalOffset })}px`
					}
				}
				// useOffsetでない場合、bottomを0にする
				return {
					bottom: "0px"
				}
			}

			return {
				top: `${top}px`
			}
		}
	},
	center: {
		calc ({ anchorEl, thisRect, useOffset, additionalOffset }) {
			const anchorRect = anchorEl.getBoundingClientRect()
			let top = anchorRect.top + anchorRect.height / 2
			if (useOffset) top = top + anchorRect.height
			top = top + additionalOffset

			const actualTop = top - thisRect.height / 2
			// 画面を上にはみ出すなら上にそろえる
			if (actualTop < 0) {
				return {
					top: "0px"
				}
			}
			// 下にはみ出すなら下にそろえる
			if (actualTop + thisRect.height > window.innerHeight) {
				return {
					bottom: "0px"
				}
			}

			return {
				top: `${top}px`,
				transform: "translateY(-50%)"
			}
		}
	},
	top: {
		calc ({ anchorEl, thisRect, useOffset, additionalOffset }) {
			const bottom = calcBottomForPostionTop({ anchorEl, thisRect, useOffset, additionalOffset })

			// 上にはみ出す場合は、topに0を指定
			if (bottom + thisRect.height >= window.innerHeight) {
				// useOffsetの場合、対象要素に被らないことが求められるため、表示位置切り替え
				if (useOffset) {
					return {
						top: `${calcTopForPositionBottom({ anchorEl, thisRect, useOffset, additionalOffset })}px`
					}
				}
				return {
					top: "0px"
				}
			}

			return {
				bottom: `${bottom}px`
			}
		}
	}
}
// x座標計算用
export const horizontalCalculators = {
	left: {
		calc ({ anchorEl, thisRect, useOffset, additionalOffset }) {
			const right = calcRightForPositionLeft({ anchorEl, thisRect, useOffset, additionalOffset })

			// 左にはみ出す場合
			if (right + thisRect.width > window.innerWidth) {
				if (useOffset) {
					return {
						left: calcLeftForPositionRight({ anchorEl, thisRect, useOffset, additionalOffset }) + "px"
					}
				}

				return {
					left: "0px"
				}
			}

			return {
				right: `${right}px`
			}
		}
	},
	center: {
		calc ({ anchorEl, thisRect, useOffset, additionalOffset }) {
			const anchorRect = anchorEl.getBoundingClientRect()
			let left = anchorRect.left + anchorRect.width / 2
			if (useOffset) left = left + anchorRect.width
			left = left - additionalOffset

			const actualLeft = left - thisRect.width / 2
			// 左にはみ出す場合は左揃え
			if (actualLeft < 0) {
				return {
					left: "0px"
				}
			}
			// 右にはみ出す場合は右揃え
			if (actualLeft + thisRect.width > window.innerWidth) {
				return {
					right: "0px"
				}
			}

			return {
				left: `${left}px`,
				transform: "translateX(-50%)"
			}
		}
	},
	right: {
		calc ({ anchorEl, thisRect, useOffset, additionalOffset }) {
			const left = calcLeftForPositionRight({ anchorEl, thisRect, useOffset, additionalOffset })

			// 右にはみ出す場合
			if (left + thisRect.width > window.innerWidth) {
				if (useOffset) {
					return {
						right: calcRightForPositionLeft({ anchorEl, thisRect, useOffset, additionalOffset }) + "px"
					}
				}

				return {
					right: "0px"
				}
			}

			return {
				left: `${left}px`
			}
		}
	}
}
